module.exports = __webpack_public_path__ + "img/playbutton10.2efc645d.png";